import { StateCreator } from 'zustand'

export interface StartDateSlice {
    startDate: string | null
    setStartDate: (date: string | null) => void
}

export const createStartDateSlice: StateCreator<StartDateSlice> = (set) => ({
    startDate: null,
    setStartDate: (date) => set({ startDate: date })
})
